import { render, staticRenderFns } from "./sample.md?vue&type=template&id=963b9622&"
import script from "./sample.md?vue&type=script&lang=js&"
export * from "./sample.md?vue&type=script&lang=js&"
import style0 from "./sample.md?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./sample.md?vue&type=custom&index=0&blockType=frontmatter"
if (typeof block0 === 'function') block0(component)

export default component.exports